import { lazy } from 'react'

export const LoyaltyProgramsLazy = lazy(() => import('./LoyaltyPrograms'))
